<template lang="pug">
div
  .content-wrap.custom-font2.june-highlight.rezeki-container
    .content-top
      .con.p-0
        img.hero-img(
          src="/new/img/events/rezeki/hero-banner.jpg"
          alt="Rezeki Challenge Free RM100"
        )

        // ===== SUBMIT VIDEO NOW =====
        section.submit-section
          //- a.submit-btn(
          //-   href="https://direct.lc.chat/12659496"
          //-   target="_blank"
          //-   rel="noopener"
          //- )
          a.submit-btn(
            href="javascript:void(0)"
            @click="openChat()"
          )
            | SUBMIT VIDEO NOW
            span.arrow &rarr;

        // ===== WINNER MOMENTS =====
        section.winners-section
          img.winners-title-img(
            src="/new/img/events/rezeki/rm100-winner-moments-title.webp"
            alt="RM100 Winner Moments"
          )

          p.winners-subtitle Real Videos From Real Players

          .carousel-wrap
            .grid#grid
              p.loading-txt(v-if="loading") Loading videos...

              p.loading-txt(v-else-if="videoError")
                | Could not load videos. Please check your connection.

              template(v-else)
                a.card(
                  v-for="(item, index) in displayVideos"
                  :key="`${item.videoId}-${index}`"
                  :href="item.link"
                  target="_blank"
                  rel="noopener"
                )
                  img.thumb(
                    :src="getThumbnail(item)"
                    :alt="item.title"
                    loading="lazy"
                  )

                  .play-btn

                  .title-overlay {{ item.title }}

          button.view-more-btn(
            type="button"
            @click="openYoutubePlaylist"
          )
            img(
              src="/new/img/events/rezeki/view-more-button.webp"
              alt="View More"
            )

        // ===== HOW TO WIN =====
        section.how-section
          img.how-title-img(
            src="/new/img/events/rezeki/how-to-win-rm100-title.webp"
            alt="How to Win RM100"
          )

          img.how-steps-img(
            src="/new/img/events/rezeki/how-to-win-rm100-steps.webp"
            alt="Step 1 Play and Win, Step 2 Shoot Video, Step 3 Get RM100"
          )

        // ===== WHAT PLAYERS BOUGHT =====
        section.bought-section
          img.bought-title-img(
            src="/new/img/events/rezeki/what-players-bought-title.webp"
            alt="What Players Bought"
          )

          img.bought-items-img(
            src="/new/img/events/rezeki/player-bought.webp"
            alt="Shopping, Beli Barang, Beli Makan"
          )

        // ===== FAQ =====
        section.faq-section
          img.faq-title-img(
            src="/new/img/events/rezeki/faq-title.webp"
            alt="Frequently Asked Questions"
          )

          .faq-list
            .faq-item(v-for="(faq, index) in faqList" :key="index")
              button.faq-q(
                type="button"
                :class="{ open: activeFaq === index }"
                @click="toggleFaq(index)"
              )
                | {{ faq.question }}
                span.arrow &and;

              .faq-a(:class="{ open: activeFaq === index }")
                template(v-if="faq.type === 'deposit'")
                  | No! Min deposit RM50 or cuci any amount qualifies for participation

                template(v-else-if="faq.type === 'submit'")
                  | A video of your purchase (
                  strong minimum 15 seconds
                  | ) with clear receipt or proof of purchase
                  br
                  br
                  | Your video must clearly mention:
                  strong  "Every Win Is EpicWin"
                  |  and
                  strong  "Thank You EpicWin"
                  br
                  br
                  | All submissions must be original and follow the campaign requirements.

                template(v-else-if="faq.type === 'limit'")
                  | Each EpicWin ID can claim up to
                  strong  THREE (3) times
                  |  throughout the campaign.
                  br
                  br
                  | Each submission must: Feature a different purchase, Include a valid receipt, Meet all campaign requirements
                  br
                  br
                  | Duplicate purchases, duplicate receipts, or reused videos will not be accepted.

                template(v-else-if="faq.type === 'buy'")
                  | Almost anything! Drinks & Coffee, Food & Family Meals, Shopping & Daily Essentials, Gifts for Family & Friends
                  br
                  br
                  | Show us how your EpicWin winnings create happiness in real life.

                template(v-else-if="faq.type === 'where'")
                  | Submit your video, receipt, and username to
                  a(
                    href="https://t.me/imEva03?text=Hi%2C%20I%20would%20like%20to%20claim%20the%20Rezeki%20100%20Bonus%20%F0%9F%8E%89"
                    target="_blank"
                    rel="noopener"
                    style="color:#fff;font-weight:700;text-decoration:underline;"
                  )  EpicWin Amoi
                  | .
                  br
                  br
                  | Our team will review your submission and contact you if additional information is required.

                template(v-else-if="faq.type === 'claim'")
                  | RM100 cashback will be credited directly into your game wallet upon approval.
                  br
                  br
                  | The RM100 cashback must be withdrawn immediately and cannot be used to play any games.
                  br
                  br
                  | Additional rewards may be awarded based on your TikTok video performance after 1 week.

                template(v-else-if="faq.type === 'viral'")
                  | Earn extra rewards based on your video's performance on
                  a(
                    href="https://www.tiktok.com/@epinwin_"
                    target="_blank"
                    rel="noopener"
                    style="color:#fff;font-weight:700;text-decoration:underline;"
                  )  EpicWin's TikTok
                  |  channel (within 1 month of posting):
                  br
                  br

                  ul.likes-list
                    li 50 Likes = RM2
                    li 100 Likes = RM5
                    li 200 Likes = RM10
                    li 500 Likes = RM25
                    li 1,000 Likes = RM50

                  br
                  | Bonus rewards will be credited after the performance review period.
  .content-wrap.pt-0
    .con
      footerInfo    
</template>

<script>
import footerInfo from '@/views/default/_footerArticle.vue'
export default {
  name: 'RezekiChallenge',
  components:{
		footerInfo,
	},
  data() {
    return {
      playlistId: 'PLAmHpU2QgEDOlblQDUvFllaigVWw3FfI8',
      youtubeApiKey: 'AIzaSyCWCeWzRwAy8vaHcifVONbBC9Ub3VezQRM',
      maxVideos: 6,

      videos: [],
      loading: true,
      videoError: false,

      activeFaq: 0,

      faqList: [
        {
          question: 'Do I need to RM100 Deposit?',
          type: 'deposit'
        },
        {
          question: 'What do I need to submit?',
          type: 'submit'
        },
        {
          question: 'How many videos can I submit?',
          type: 'limit'
        },
        {
          question: 'What can I buy with RM100?',
          type: 'buy'
        },
        {
          question: 'Where do I submit my video?',
          type: 'where'
        },
        {
          question: 'How to claim RM100 rewards?',
          type: 'claim'
        },
        {
          question: 'How to claim additional viral rewards?',
          type: 'viral'
        }
      ]
    }
  },

  computed: {
    youtubeApiUrl() {
      return `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=${this.maxVideos}&playlistId=${this.playlistId}&key=${this.youtubeApiKey}`
    },

    playlistUrl() {
      return `https://www.youtube.com/playlist?list=${this.playlistId}`
    },

    displayVideos() {
      return [...this.videos, ...this.videos]
    }
  },
  created(){
		$('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/rezeki`);
		// this.getSeo("contactUs")
	},
  mounted() {
    window.scroll(0, 0)
    document.body.classList.add("custom-padding")
    this.loadVideos()
  },

  beforeDestroy() {
    document.body.classList.remove("custom-padding")
  },

  methods: {
    openChat() {
      LiveChatWidget.call("maximize");
    },

    async loadVideos() {
      this.loading = true
      this.videoError = false

      try {
        const res = await fetch(this.youtubeApiUrl)
        const data = await res.json()

        if (!res.ok) {
          throw new Error(data.error?.message || `YouTube API error: ${res.status}`)
        }

        if (!data.items || data.items.length === 0) {
          throw new Error('No items')
        }

        this.videos = data.items
          .map(item => {
            const snippet = item.snippet || {}
            const videoId = snippet.resourceId?.videoId || ''

            return {
              videoId,
              title: snippet.title || '',
              link: `https://www.youtube.com/watch?v=${videoId}`,
              thumbnail:
                snippet.thumbnails?.maxres?.url ||
                snippet.thumbnails?.standard?.url ||
                snippet.thumbnails?.high?.url ||
                snippet.thumbnails?.medium?.url ||
                snippet.thumbnails?.default?.url ||
                `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`
            }
          })
          .filter(item => item.videoId)
      } catch (error) {
        console.error(error)
        this.videoError = true
        this.videos = []
      } finally {
        this.loading = false
      }
    },

    getThumbnail(item) {
      if (!item) {
        return ''
      }

      return item.thumbnail || `https://i.ytimg.com/vi/${item.videoId}/hqdefault.jpg`
    },

    openYoutubePlaylist() {
      window.open(this.playlistUrl, '_blank', 'noopener')
    },

    toggleFaq(index) {
      this.activeFaq = this.activeFaq === index ? null : index
    }
  }
}
</script>

<style lang="css" scoped>
/* *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; } */

.rezeki-container{
  margin: 0; padding: 0; box-sizing: border-box; 
}

.content-top{
  padding-top: 70px;
  @media(max-width: 767px){
    padding-top: 60px;
  }
}

.custom-font2 {
  background: #0d0225;
  font-family: Arial, 'Helvetica Neue', sans-serif;
  color: #fff;
  overflow-x: hidden;
  max-width: 480px;
  margin: 0 auto;
}

.hero-img {
  width: 100%;
  display: block;
}

/* =====================
    SUBMIT VIDEO NOW
===================== */
.submit-section {
  background: #0d0225;
  padding: 16px 14px;
}

.submit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  background: linear-gradient(90deg, #FFD700 0%, #ffec6e 50%, #FFD700 100%);
  background-size: 200% auto;
  color: #111;
  font-size: 18px;
  font-weight: 900;
  padding: 18px 20px;
  border-radius: 10px;
  border: 3px solid #111;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-decoration: none;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  animation: pulseGlow 1.6s ease-in-out infinite, shimmer 2.4s linear infinite;
  box-shadow:
    0 0 0 0 rgba(255,215,0,0.7),
    0 4px 20px rgba(255,215,0,0.45);
}

@keyframes pulseGlow {
  0%, 100% { box-shadow: 0 0 0 0 rgba(255,215,0,0.7), 0 4px 20px rgba(255,215,0,0.4); }
  50%       { box-shadow: 0 0 0 10px rgba(255,215,0,0), 0 4px 32px rgba(255,215,0,0.8); }
}

@keyframes shimmer {
  0%   { background-position: 200% center; }
  100% { background-position: -200% center; }
}

.submit-btn::after {
  content: '';
  position: absolute;
  top: 0;
  left: -75%;
  width: 50%;
  height: 100%;
  background: linear-gradient(120deg, transparent 0%, rgba(255,255,255,0.45) 50%, transparent 100%);
  animation: sweep 2.4s linear infinite;
}

@keyframes sweep {
  0%   { left: -75%; }
  100% { left: 125%; }
}

.submit-btn:hover {
  transform: scale(1.03);
  transition: transform 0.15s ease;
}

.submit-btn .arrow {
  font-size: 22px;
  font-weight: 900;
  animation: bounce 0.8s ease-in-out infinite alternate;
}

@keyframes bounce {
  from { transform: translateX(0); }
  to   { transform: translateX(6px); }
}

/* =====================
    WINNER MOMENTS
===================== */
.winners-section {
  background: #0d0225;
  text-align: center;
  padding: 28px 0 28px;
}

.winners-title-img {
  max-width: 380px;
  margin: 0 auto 6px;
  display: block;
  width: 90%;
}

.winners-subtitle {
  font-size: 13px;
  color: #bbb;
  margin-bottom: 20px;
  letter-spacing: 0.5px;
}

.carousel-wrap {
  width: 100%;
  overflow: hidden;
  margin-bottom: 24px;
}

.grid {
  display: flex;
  gap: 10px;
  padding: 0 12px;
  width: max-content;
  animation: scrollLeft 20s linear infinite;
}

.grid:hover { animation-play-state: paused; }

@keyframes scrollLeft {
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

.card {
  position: relative;
  width: 130px;
  flex-shrink: 0;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  background: #000;
  text-decoration: none;
  border: 2px solid rgba(150,80,255,0.25);
}

.card .thumb {
  width: 100%;
  aspect-ratio: 9 / 16;
  object-fit: cover;
  display: block;
}

.card .play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 44px;
  height: 44px;
  background: rgba(0,0,0,0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.card .play-btn::after {
  content: '';
  display: block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 9px 0 9px 16px;
  border-color: transparent transparent transparent #fff;
  margin-left: 3px;
}

.card:hover .play-btn { background: rgba(255,0,0,0.85); }

.card .title-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0,0,0,0.85));
  color: #fff;
  font-size: 9px;
  padding: 20px 6px 7px;
  line-height: 1.3;
}

.view-more-btn {
  cursor: pointer;
  border: none;
  background: none;
  padding: 0;
  display: inline-block;
}

.view-more-btn img {
  max-width: 200px;
  display: block;
}

.loading-txt {
  color: #888;
  font-size: 13px;
  padding: 24px;
  text-align: center;
}

/* =====================
    HOW TO WIN
===================== */
.how-section {
  background: #0d0225;
  text-align: center;
  padding: 28px 0 0;
}

.how-title-img {
  max-width: 320px;
  margin: 0 auto 18px;
  display: block;
  width: 85%;
}

.how-steps-img {
  width: 100%;
  display: block;
}

/* =====================
    WHAT PLAYERS BOUGHT
===================== */
.bought-section {
  background: #0d0225;
  text-align: center;
  padding: 32px 12px 36px;
}

.bought-title-img {
  max-width: 380px;
  margin: 0 auto 18px;
  display: block;
  width: 90%;
}

.bought-items-img {
  width: 100%;
  display: block;
}

/* =====================
    FAQ
===================== */
.faq-section {
  background: #0d0225;
  padding: 32px 0 48px;
  @media(max-width: 767px){
    padding: 32px 0 70px;
  }
}

.faq-title-img {
  max-width: 420px;
  margin: 0 auto 22px;
  display: block;
  width: 95%;
}

.faq-list {
  padding: 0 12px;
}

.faq-item {
  background: #1c0b42;
  border-radius: 8px;
  margin-bottom: 8px;
  overflow: hidden;
  border: 1px solid rgba(150,80,255,0.2);
}

.faq-q {
  width: 100%;
  background: transparent;
  border: none;
  text-align: left;
  padding: 14px 16px;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.faq-q .arrow {
  font-size: 14px;
  color: #a78bfa;
  transition: transform 0.3s;
  flex-shrink: 0;
}

.faq-q.open .arrow { transform: rotate(180deg); }

.faq-a {
  display: none;
  padding: 2px 16px 14px;
  font-size: 12px;
  color: #ccc;
  line-height: 1.75;
  border-top: 1px solid rgba(150,80,255,0.15);
}

.faq-a.open { display: block; }

.faq-a strong { color: #fff; font-weight: 700; }

.likes-list {
  list-style: none;
  margin-top: 8px;
}

.likes-list li { padding: 2px 0; }
</style>